// extracted by mini-css-extract-plugin
module.exports = {"statementBox":"style_statementBox__3ztX9","statementInnerBox":"style_statementInnerBox__1QCMh"};